import React, { useState, useEffect } from "react";
import Samples from "./Samples";
import RegisterRetestSample from "../registration/RegisterRetestSample";
import Button from "../Button";
import { fetchJson } from "../../lib/Fetching";

export default function SampleRetestSamples({ sampleId, clientView }) {
  const [addRetest, setAddRetest] = useState(false);
  const [sampleList, setSampleList] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchSampleRetests = () => {
    fetchJson("/lims_sample_reporting/samples/" + sampleId + "/sample_retests.json", {}).then(
      (json) => {
        setLoading(false);
        setSampleList(json.sample_list);
        if (!json.sample_list || json.sample_list.samples.length == 0) {
          setAddRetest(true);
        }
      }
    );
  };

  useEffect(
    () => {
      fetchSampleRetests();
    },
    [sampleId]
  );

  if (loading)
    return (
      <div style={{ padding: 10 }}>
        <i className="fa fa-spin fa-spinner" />
        &nbsp;Loading...
      </div>
    );

  return (
    <div style={{ padding: 10, overflow: "auto" }}>
      <Button
        title={addRetest ? "Cancel Retest" : "Perform Retest"}
        onClick={() => setAddRetest(!addRetest)}
        style={{ marginBottom: 0 }}
      />
      {addRetest && (
        <RegisterRetestSample
          sampleId={sampleId}
          onCancel={() => setAddRetest(false)}
          onCompleted={() => {
            setAddRetest(false);
            fetchSampleRetests();
          }}
        />
      )}
      {loading && <i className="fa fa-spin fa-spinner" />}
      {sampleList && (
        <div style={{ marginTop: 10 }}>
          <Samples
            key={sampleList.samples.map((s) => s.identifier)}
            sample_list={sampleList}
            showAttributes={false}
            clientView={clientView}
            reloadData={fetchSampleRetests}
            showAttributes={false}
          />
        </div>
      )}
    </div>
  );
}
